import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IStateParamsService } from 'angular-ui-router';
import { Observable, Observer, of } from 'rxjs';
import { delayWhen, flatMap, take } from 'rxjs/operators';
import {
  getRollupGroupingData,
  getRollupGroupingLoadedStatus,
} from 'Src/ng2/store/selectors/rollup-grouping-selectors/rollup-grouping-selectors';
import {
  IRollupGroupingPayload,
  LoadRollupGrouping,
} from './../../../../store/actions/rollup-grouping-actions/rollup-grouping-actions';

@Injectable()
export class RollupGroupingDataService {
  constructor(
    public store: Store<any>,
    @Inject('$stateParams')
    private $stateParams: IStateParamsService,
  ) {}

  getRollupGroupingPayload(focusData, schoolId: string, tileFilter: string) {
    const popFilter = focusData.graphQlKeyPopulationFilter;
    const rollupPayload = {
      schoolId,
      filterKeys: tileFilter ? [tileFilter, popFilter] : [focusData.defaultFilter.graphQlKey, popFilter],
      groupingKey: this.$stateParams.grouping,
      columns: focusData.midLevelColumns.map(({ graphQlKey }) => graphQlKey),
    };
    return of(rollupPayload);
  }

  getRollupData$(payload: IRollupGroupingPayload): Observable<any> {
    return this.store.select(getRollupGroupingLoadedStatus).pipe(
      delayWhen((loaded: boolean) => this.loadRollupData$(loaded, payload)),
      flatMap(() => this.store.select(getRollupGroupingData)),
      take(1),
    );
  }

  loadRollupData$(loaded: boolean, rollupPayload: IRollupGroupingPayload): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      if (!loaded) {
        this.store.dispatch(new LoadRollupGrouping(rollupPayload));
      } else {
        observer.next('rollup loaded');
        observer.complete();
      }
    });
  }
}
